var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2662 17.1875H23.7638C25.1424 17.1875 26.8332 18.0618 27.5387 19.1406L30.6306 23.8631H36.2512C36.9406 23.8631 37.5 24.3725 37.5 25C37.5 25.6275 36.9406 26.1369 36.2512 26.1369H30.512L27.4201 30.8594C26.7145 31.9382 25.0237 32.8125 23.6451 32.8125H21.1476L25.517 26.1369H16.7895L14.9975 28.9256H12.5L15.0225 25V24.9625L12.525 21.0744H15.0225L16.8132 23.8631H25.6356L21.2662 17.1875Z",
    fill: "#717075"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.0ecf06afd670d349034bb01656cdc29f.svg";
export { ForwardRef as ReactComponent };